import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'enum',
})
export class EnumPipe implements PipeTransform {
  transform(value: string, enumClass: Record<string | number, string>): string {
    return enumClass[value] ? enumClass[value] : value;
  }
}
